import { LoaderCircle } from "lucide-react";

// Shared Suspense fallback so lazy route chunks never resolve into a blank content area while loading.
export function RouteFallback() {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex min-h-[40vh] flex-col items-center justify-center gap-3 text-center"
    >
      <div className="flex h-11 w-11 items-center justify-center rounded-2xl border border-border bg-card shadow-sm">
        <LoaderCircle className="h-5 w-5 animate-spin text-primary" />
      </div>
      <p className="text-sm text-muted-foreground">Loading…</p>
    </div>
  );
}
